/**
 * CDB54 Calendrier+ - Application Entry Point
 * Initializes Vue.js application with Pinia, Router, and i18n
 */

import './bootstrap';
import { createApp } from 'vue';
import router from '@/router';
import pinia from '@/stores';
import i18n from '@/i18n';
import App from '@/App.vue';

// Note: Bootstrap SCSS is imported via Vite in app.blade.php
// This ensures proper SCSS compilation with our custom variables

// Initialize Vue application
const app = createApp(App);

// Register plugins
app.use(pinia);
app.use(router);
app.use(i18n);

// Mount the application
app.mount('#app');
